import {createRouter, createWebHashHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TutorialView from '../views/tutorial/TutorialView.vue'
import LoginView from '../views/authentication/LoginView.vue'
import RegistrationView from '../views/authentication/RegistrationView.vue'
import PasswordResetView from '../views/authentication/PasswordResetView.vue'
import DiagnosticsSearchView from '../views/diagnostics/DiagnosticsSearchView.vue'
import ProfileSettingsView from '../views/settings/ProfileSettingsView.vue'
import ManageUsersView from '../views/settings/ManageUsersView.vue'
import AdvisoryActivitiesView from "../views/advice/AdvisoryActivitiesView.vue"
import {sharedState} from '../store'
import ManageSystemView from "@/views/settings/ManageSystemView.vue";
import TrainingResourcesView from "@/views/training/TrainingResourcesView.vue";
import ActivationView from "@/views/authentication/ActivationView.vue";
import FarmerAdviceView from "@/views/advice/FarmerAdviceView.vue";
import GroupAdviceView from "@/views/advice/GroupAdviceView.vue";
import SuccessStoriesView from "@/views/success/SuccessStoriesView.vue";
import CollaborationView from "@/views/collaboration/CollaborationView.vue";
import LogoutView from "@/views/authentication/LogoutView.vue";
import TemplatesView from "@/views/templates/TemplatesView.vue";

const routes = [
    {
        path: '/',
        name: 'root',
        component: LoginView,
    },
    {
        path: '/home',
        name: 'home',
        component: HomeView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/login')
            }
        }
    },
    {
        path: '/tutorials',
        name: 'tutorials',
        component: TutorialView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/home');
            }
        }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next('/home');
            }
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: LogoutView,
    },
    {
        path: '/register',
        name: 'register',
        component: RegistrationView
    },
    {
        path: '/activation/:email',
        name: 'activation',
        component: ActivationView
    },
    {
        path: '/reset',
        name: 'reset',
        component: PasswordResetView
    },
    {
        path: '/diagnostics',
        name: 'diagnostics',
        component: DiagnosticsSearchView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/login')
            }
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: ProfileSettingsView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/login')
            }
        }
    },
    {
        path: '/manage-users',
        name: 'manage-users',
        component: ManageUsersView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/login')
            }
        },
    },
    {
        path: '/manage-system',
        name: 'manage-system',
        component: ManageSystemView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/login')
            }
        },
    },
    {
        path: '/advice',
        name: 'advice',
        component: AdvisoryActivitiesView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/login')
            }
        }
    },
    {
        path: '/farmer-advice',
        name: 'farmer-advice',
        component: FarmerAdviceView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/login')
            }
        }
    },
    {
        path: '/group-advice',
        name: 'group-advice',
        component: GroupAdviceView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/login')
            }
        }
    },
    {
        path: '/training',
        name: 'training',
        component: TrainingResourcesView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/login')
            }
        }
    },
    {
        path: '/success',
        name: 'success',
        component: SuccessStoriesView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/success')
            }
        }
    },
    {
        path: '/collaboration',
        name: 'collaboration',
        component: CollaborationView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/collaboration')
            }
        }
    },
    {
        path: '/templates',
        name: 'templates',
        component: TemplatesView,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('access_token')) {
                next();
            } else {
                next('/templates')
            }
        }
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAdmin) {
        if (sharedState.user_isAdmin === true) {
            next();
        } else {
            next('/home');
        }
    } else {
        next();
    }
});

export default router
